import React, { useState } from 'react';
import { PageType, EXPERIMENTS } from '@app/config';
import { useExperiment } from '@app/experiments';
import { useDynamicProductRow, useExtendedProducts } from './hooks';
import { Loading } from './Loading';
import DynamicProductRow from './DynamicProductRow';
import DynamicExtendedProductRow from './DynamicExtendedProductRow';

export type DynamicProductRowContainerProps = {
  screenName: PageType;
  collection: string;
  enabled: boolean;
};

const DynamicProductRowContainer = ({
  enabled,
  screenName,
  collection,
}: DynamicProductRowContainerProps) => {
  const MIN_LENGTH = 1;
  const isExtendedHomepageCarousel =
    useExperiment(EXPERIMENTS.ab_carousel_extend_home_web) === 'true';

  const [extendedPage, setExtendedPage] = useState(0);

  const {
    products,
    totalProducts,
    tileType,
    priceType,
    footnotesType,
    title,
    seeAllCTA,
    trackingEvent,
    helpMessage,
    loading,
  } = useDynamicProductRow({
    collection,
    enabled,
  });

  const { extendedProducts, loadingExtendedProducts } = useExtendedProducts({
    isExtendedHomepageCarousel,
    collection,
    page: extendedPage,
  });

  if (loading) {
    return <Loading />;
  }

  if (products?.length < MIN_LENGTH) {
    return null;
  }

  if (isExtendedHomepageCarousel && totalProducts > 6) {
    return (
      <DynamicExtendedProductRow
        totalProducts={totalProducts}
        header={title}
        baseProducts={products}
        extendedProducts={extendedProducts}
        extendedPage={extendedPage}
        loadingExtendedProducts={loadingExtendedProducts}
        setExtendedPage={setExtendedPage}
        screenName={screenName}
        swooshName={trackingEvent}
        tileType={tileType}
        priceType={priceType}
        footnotesType={footnotesType}
        seeAllCTA={seeAllCTA}
        trackingEvent={trackingEvent}
        helpMessage={helpMessage}
      />
    );
  }

  return (
    <DynamicProductRow
      header={title}
      products={products}
      screenName={screenName}
      swooshName={trackingEvent}
      tileType={tileType}
      priceType={priceType}
      footnotesType={footnotesType}
      seeAllCTA={seeAllCTA}
      trackingEvent={trackingEvent}
      helpMessage={helpMessage}
    />
  );
};

export default DynamicProductRowContainer;
